import { commonBase } from '@kid/meta-color/color/output/all';
import { useRem } from '../../hooks/useRem';
import { useStyle } from '../../hooks/useStyle';
export function useStepperStyle() {
    const rem = useRem();
    const style = useStyle({
        value: {
            flexDirection: 'row',
        },
        box: {
            borderWidth: 1,
            borderColor: commonBase.kiui_color_base_black_19,
            width: rem(24),
            height: rem(24),
            textAlign: 'center',
            lineHeight: 22,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
        },
        left: {
            borderTopLeftRadius: 2,
            borderBottomLeftRadius: 2,
        },
        right: {
            borderTopRightRadius: 2,
            borderBottomRightRadius: 2,
        },
        disabled: {
            color: commonBase.kiui_color_base_black_20,
        },
        input: {
            borderTopWidth: 1,
            borderTopColor: commonBase.kiui_color_base_black_19,
            borderBottomWidth: 1,
            borderBottomColor: commonBase.kiui_color_base_black_19,
            width: rem(40),
            height: rem(24),
            fontSize: 14,
            textAlign: 'center',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: '#000',
            paddingVertical: 0,
        },
    });
    return {
        style,
    };
}
